import { useEffect, useState } from "react";

const STORAGE_KEY = "ih_recently_viewed";
const MAX_ITEMS = 8;

export function useRecentlyViewed(currentId?: string): string[] {
  const [ids, setIds] = useState<string[]>(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as string[]) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    if (!currentId) return;

    setIds((prev) => {
      const filtered = prev.filter((id) => id !== currentId);
      const updated = [currentId, ...filtered].slice(0, MAX_ITEMS);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      } catch {
        // storage quota exceeded — silently ignore
      }
      return updated;
    });
  }, [currentId]);

  // Return all IDs except the current product
  return ids.filter((id) => id !== currentId);
}
